module.exports = __webpack_public_path__ + "img/md-thumbs-down.6a2f8e08.svg";